import * as _ from 'underscore';

import {camelCase} from '../../../shared';
import {DatasetField, HeaderField} from '..';

export class Dataset {
   id:string;
   title:string;
   type:string;
   selectAction:string;
   fields:DatasetField[];
   headers:HeaderField[][];

   groupBy:DatasetField;
   xAxis:DatasetField;
   yAxis:DatasetField;

   constructor(dataset:any) {
      this.id = dataset.id;
      this.title = dataset.title;
      this.type = dataset.type;

      this.selectAction = dataset.selectAction;
      this.fields = _.map(dataset.fields, (f) => {
         return new DatasetField(f);
      });

      if (dataset.headers) {
         this.headers = _.map(dataset.headers as any[][], r => _.map(r, c => new HeaderField(c)));
      }

      if (dataset.groupBy) {
         this.groupBy = _.findWhere(this.fields, {name: camelCase(dataset.groupBy)});
      }

      if (dataset.xAxis) {
         this.xAxis = _.findWhere(this.fields, {name: camelCase(dataset.xAxis)});
      }

      if (dataset.yAxis) {
         this.yAxis = _.findWhere(this.fields, {name: camelCase(dataset.yAxis)});
      }
   }

   get isTable():boolean {
      return this.type.indexOf('table') == 0;
   }

   get isChart():boolean {
      return this.type == 'table-expanded' || (this.type.indexOf('table') == -1 && this.type != 'download-only' && this.type != 'spreadsheet-tabs');
   }

   get isDownloadOnly():boolean {
      return this.type == 'download-only' || this.type == 'spreadsheet-tabs';
   }

   get cssClass() {
      // avoid conflict with Bootstrap class
      return this.type == 'table' ? 'report-table' : this.type;
   }
}
